import { LGPDInvite } from '../../interfaces/commons.interface';
import { PaymentMethodType } from '../../../constants/paymentMethodType.enum';

export interface Order {
  id: string;
  referenceNumber: string;
  details: Details;
  status: keyof typeof OrderStatus;
  transactionId?: string;
}

export interface Boleto {
  id?: string;
  barcode: string;
  downloadUrl?: string;
  expirationDate: string;
}

export interface Pix {
  code: string;
  base64?: string;
  expirationDate: string;
}

export interface Card {
  bin: string;
  holderName: string;
  method: string;
  encrypted: string;
}

export interface Link {
  id: string;
  referenceNumber: string;
  paymentLink: string;
}

export interface Details {
  id: string;
  amount: number;
  payments: Payment[];
  store: Store;
  customer: Customer;
  products?: Product[];
  services?: Service[];
  delivery: Delivery;
  shipping?: Shipping;
  card?: Card;
  boleto?: Boleto;
  pix?: Pix;
  purposePurchase?: string;
}

export interface PaymentBase {
  id: string;
  type: PaymentMethodType.BANK_SLIP | PaymentMethodType.PIX;
  amount: number;
  installments: number;
  description: string;
}

export interface PaymentCard extends Omit<PaymentBase, 'type'> {
  type: PaymentMethodType.CARD;
  simulated?: SimulatedPayment;
}

export type Payment = PaymentBase | PaymentCard;

export interface SimulatedPayment {
  cardBanner: string;
  installmentValue: number;
  interest: number;
  interestValue: number;
  taxValue: number;
  cet: number;
  totalAmount: number;
}

export interface Store {
  id: number;
}

export interface Customer {
  documentNumber: string;
  name: string;
  email?: string;
  birthDate?: string;
  cel?: string;
  address?: Address;
}

export interface Assembly {
  id: string;
  quantity: number;
  value: number;
}

export interface Service {
  id: string;
  description: string;
  quantity: number;
  value: number;
  type?: ServiceType;
  ticket?: boolean;
}

export interface Product {
  id: string;
  image: string;
  description: string;
  value: number;
  quantity: number;
  assembly?: Assembly;
  seller?: Seller;
  services?: Service[];
}

export interface Seller {
  id: string;
  description?: string;
}

export interface Address {
  neighbourhood: string;
  street: string;
  number: string;
  zipCode: string;
  city: string;
  state: string;
  complement?: string;
}

export interface Delivery {
  type: 'pickupstore' | 'conventional';
  description: string;
  address?: Address;
}

export interface Shipping {
  value: number;
}

export interface ServiceType {
  id: number;
}

export enum OrderStatus {
  AWAITING_PAYMENT = 'AWAITING_PAYMENT',
  AUTHORIZED = 'AUTHORIZED',
  DENIED = 'DENIED',
  PAID = 'PAID',
  VOIDED = 'VOIDED',
  REFUNDED = 'REFUNDED',
}

export enum PaymentType {
  BOLETO = '5',
  PIX = '675',
  PIX_MKT = 'pix',
}

export interface OrderLGPD {
  order: Order;
  lgpd?: LGPDInvite;
  showMessageToken?: boolean;
}
